import { observable } from 'mobx';
import { SerializedData, FetchOptions } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsShoppingPwaFlightServicingConfirmationResults } from 'src/__generated__/api';

export class ServicingConfirmationCriteriaStore extends Store {
  @observable public servicingConfirmationCriteria: FlightsShoppingPwaFlightServicingConfirmationResults.Variables;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const { query } = fetchOptions;

    this.servicingConfirmationCriteria.flightsServicingConfirmationCriteria.journeyContinuationId =
      query?.journeyContinuationId;
    this.servicingConfirmationCriteria.flightsServicingConfirmationCriteria.originalBookingId =
      query?.originalBookingId;
    this.servicingConfirmationCriteria.flightsServicingConfirmationCriteria.tripId = query?.tripId;
  }
}

ServicingConfirmationCriteriaStore.DEFAULTS = {
  servicingConfirmationCriteria: {
    flightsServicingConfirmationCriteria: {
      journeyContinuationId: '',
      originalBookingId: '',
      tripId: ''
    }
  }
};
